module.exports = __webpack_public_path__ + "img/clip-list-is-empty.0b2906ab.png";